import { Component } from 'shimmer'

import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader'
import { FloatType, sRGBEncoding } from 'three'

export class EnvMap extends Component {
  constructor () {
    super()

    this.applyMap = this.applyMap.bind(this)

    this.promises = []

    this.promisObjectLoaded = new Promise((resolve) => {
      this.resolveObject = resolve
    })

    const envMapPromise = this.loadEnvMap()

    this.promises.push(envMapPromise, this.promisObjectLoaded)

    Promise.all(this.promises).then(() => {
      this.resolve()
      this.treatObjects()
    })
  }

  applyMap (obj) {
    obj.material.envMap = this.cubemap
    obj.material.envMapIntensity = .05
    obj.material.needsUpdate = true
  }

  loadEnvMap () {
    return new Promise( (resolve, reject) => {

      new HDRCubeTextureLoader().setDataType(FloatType).setPath( '/images/textures/cubemap--4/' ).load([
        'nz.hdr',
        'nz.hdr',
        'nz.hdr',
        'nz.hdr',
        'nz.hdr',
        'nz.hdr'
      ], texture => {
        // texture.encoding = sRGBEncoding
        this.cubemap = texture
        resolve()
      })
    })
  }
}

export const envMap = new EnvMap()